<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{ error: NuxtError }>()
const notFound = computed(() => props.error.statusCode === 404)
useHead({ title: notFound.value ? 'Not found — Regotiate' : 'Something went wrong — Regotiate' })
</script>

<template>
  <NuxtLayout name="default">
    <div class="container container--narrow page err">
      <p class="err__code">{{ error.statusCode }}</p>
      <h1 class="h1">{{ notFound ? 'We couldn’t find that page' : 'Something went wrong' }}</h1>
      <p class="muted">{{ error.statusMessage || error.message }}</p>
      <button type="button" class="btn btn-primary" @click="clearError({ redirect: '/' })">Back to home</button>
    </div>
  </NuxtLayout>
</template>

<style scoped>
.err {
  display: grid;
  justify-items: start;
  gap: 12px;
  padding-top: 64px;
}

.err__code {
  font-weight: 600;
  color: var(--brand-700);
}

.err .btn {
  margin-top: 16px;
}
</style>
